import React from "react"
import cx from "classnames"

import { Detail, Image } from "../../elements"
import { GraphCms_Contributor } from "../../../../graphql-types"

type Props = {
  className?: string
  contributor: GraphCms_Contributor
}

function ContributorCard({ contributor, className }: Props) {
  return (
    <div className={cx("p-4 flex items-center bg-gradient rounded", className)}>
      <Image
        className="block rounded-full w-16 mr-4"
        gatsbyImageData={
          contributor.avatar?.localFile?.childImageSharp?.gatsbyImageData
        }
        alt={contributor.name}
      />
      <div>
        <Detail className="text-lg italic font-bold mb-1">
          {contributor.name}
        </Detail>
        <Detail className="text-sm italic text-gray-dark mb-1">
          {`${contributor.age} yaşında`}
        </Detail>
        {contributor.occupation && (
          <Detail className="text-sm italic text-gray-dark">
            {contributor.occupation}
          </Detail>
        )}
      </div>
    </div>
  )
}

export default ContributorCard
